export const initUser = ({ dispatch }) => {
};

export const cleanUpUser = ({ commit }) => {
};
